import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_ENDPOINT;

export const fetchFinance = createAsyncThunk(
  "finance-simulation",
  async (_, { getState, rejectWithValue }) => {
    try {
      const token = getState().auth.token || localStorage.getItem("authToken");

      if (!token) {
        return rejectWithValue("Token not found");
      }

      const response = await axios.get(`${API_URL}/finance-simulation`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      
      return response.data.data.data;
    } catch (error) {
      console.error("Error fetching finance simulation data:", error);
      return rejectWithValue(
        error.response?.data || "Failed to fetch finance simulation data"
      );
    }
  }
);

const financeSlice = createSlice({
  name: "financeSimulation",
  initialState: {
    finance_simulation: [],
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFinance.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchFinance.fulfilled, (state, action) => {
        state.isLoading = false;
        state.finance_simulation = action.payload;
      })
      .addCase(fetchFinance.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
  },
});

export default financeSlice.reducer;
